import http from '@/utils/httpService';
import { rootPath, rootPath2 } from '@/utils/globalParam';

//查询字典
export const queryDic = data => http.Axios.post(rootPath + '/api/bsc/dic/getDicItems', data, { noLoading: true });
// 查询机构列表
export const queryOrgList = data => http.Axios.post(rootPath + '/api/bsc/org/getOrgList', data, { noLoading: true });

export const queryDicItems = data => http.Axios.post(rootPath + '/api/bsc/dic/getDicItems', data, { noLoading: true });

//查询bsc和bbc的用户字典
export const getBscAndBbcUserNameDicItems = data => http.Axios.post(rootPath + '/api/bsc/dic/getBscAndBbcUserNameDicItems', data,{ noLoading: true });
